/*
The below function shows when t6he notification was sent.
Format example: 1 day ago, 2 hours ago, 4 weeks ago, 3 months ago, etc
*/

const timeSince = (date: any) => {
	const seconds = Math.floor((new Date().getTime() - date) / 1000);

	/* Years */

	let interval = seconds / 31536000;

	if (interval >= 1 && interval < 2) {
		return Math.floor(interval) + "Y";
	} else if (interval >= 2) {
		return Math.floor(interval) + "Y";
	}

	/* Months */

	interval = seconds / 2592000;
	if (interval >= 1 && interval < 2) {
		return Math.floor(interval) + "M";
	} else if (interval > 2) {
		return Math.floor(interval) + "M";
	}

	/* Weeks */

	interval = seconds / 604800;
	if (interval >= 1 && interval < 2) {
		return Math.floor(interval) + "w";
	} else if (interval >= 2) {
		return Math.floor(interval) + "w";
	}

	/* Days */

	interval = seconds / 86400;
	if (interval >= 1 && interval < 2) {
		return Math.floor(interval) + "d";
	} else if (interval >= 2) {
		return Math.floor(interval) + "d";
	}

	/* Hours */

	interval = seconds / 3600;
	if (interval >= 1 && interval < 2) {
		return Math.floor(interval) + "h";
	} else if (interval >= 2) {
		return Math.floor(interval) + "h";
	}

	/* Minutes */

	interval = seconds / 60;
	if (interval >= 1 && interval < 2) {
		return Math.floor(interval) + "m";
	} else if (interval >= 2) {
		return Math.floor(interval) + "m";
	}

	/* Seconds */

	return Math.floor(seconds) + "S";
};

export default timeSince;
